import React from "react";
import { connect } from "react-redux";
import { toString } from "utils/helpers";
import { changeTab } from "containers/ChannelsPage/actions";
import { getIn } from "utils/helpers";

import { ColorPickerButton } from "components/InputField/File";
import Button from "components/Button";
import H4 from "components/H4";
import {
  AppPreview,
  PhotoFilterPreview,
  ChannelInputField,
} from "./components";
import SwitchField from "components/SwitchField";
import {
  StyledForm,
  DisabledTabWrapper,
  FilterToggleGroupContainer,
  FieldHead,
  FormGroupWithoutBorderBottom,
} from "./styledComponents";
import { Controller, useWatch } from "react-hook-form";
const restrictText = (e) => {
  const { value } = e.target;

  if (value.length === 25) {
    e.preventDefault();
  }
};
const LogoForm = ({
  onSubmit,
  nextTab,
  submitting,
  pristine,
  backgroundColor,
  openColorPickerModal,
  themeId,
  channelThemes,
  edit,
  isNew,
  themeInstanceId,
  channelThemeInstances,
  goToThemeTab,
  onShrinkChange,
  reRenderFunction,
  form,
}) => {
  const { control, handleSubmit } = form;
  const values = useWatch({ control: control });
  const appColor = values["app_background_color"];
  const firstLine = values["first_line_text"];
  const secondLine = values["second_line_text"];
  const withGraphic = values["with_photo_filter_graphic"];
  const withFilter = values["with_photo_filter"];

  const themeInstanceKey = themeInstanceId;
  const themeInstance = isNew ? null : channelThemeInstances[themeInstanceKey];
  const themeKeyFromInstance = themeInstance && themeInstance.channel_theme_id;
  const themeKey = toString(themeId || themeKeyFromInstance);
  const selectedTheme = channelThemes[themeKey];
  const secondLineEnabled =
    (!!selectedTheme && !!selectedTheme.second_line_max_size) ||
    !!getIn(channelThemes, [themeKeyFromInstance, "second_line_max_size"]);
  const defaultFirstLine =
    selectedTheme && selectedTheme.default_first_line_text;
  const defaultSecondLine =
    selectedTheme && selectedTheme.default_second_line_text;

  return !!selectedTheme || !!themeInstance ? (
    <StyledForm onSubmit={handleSubmit(onSubmit)}>
      <div className="channel-forms__theme-form-wrapper">
        <AppPreview
          shrink
          onShrinkChange={onShrinkChange}
          firstLineFieldName="first_line_font_shrink"
          secondLineFieldName="second_line_font_shrink"
          selectedTheme={selectedTheme}
          themeInstance={themeInstance}
          backgroundColor={backgroundColor}
          keydownIsActive
          appColor={appColor}
          firstLine={firstLine}
          secondLine={secondLine}
        />
        <PhotoFilterPreview
          small
          selectedTheme={selectedTheme}
          themeInstance={themeInstance}
          firstLine={firstLine}
          secondLine={secondLine}
          withGraphic={withGraphic}
          withFilter={withFilter}
        />
        <div className="channel-forms__theme-fields">
          <Controller
            control={control}
            name="first_line_text"
            render={({ field: { ref, ...fieldRest } }) => (
              <ChannelInputField
                name="first_line_text"
                type="text"
                component={ChannelInputField}
                label="Logo Line 1"
                placeholder={defaultFirstLine}
                onChange={restrictText}
                field={fieldRest}
                {...fieldRest}
              />
            )}
          />
          {secondLineEnabled && (
            <Controller
              control={control}
              name="second_line_text"
              render={({ field: { ref, ...fieldRest } }) => (
                <ChannelInputField
                  name="second_line_text"
                  type="text"
                  component={ChannelInputField}
                  label="Logo Line 2"
                  placeholder={defaultSecondLine}
                  onChange={restrictText}
                  field={fieldRest}
                  {...fieldRest}
                />
              )}
            />
          )}
          <Controller
            control={control}
            name="app_background_color"
            render={({ field: { ref, ...fieldRest } }) => (
              <ColorPickerButton
                name="app_background_color"
                label="Background"
                buttonText={backgroundColor}
                onClick={openColorPickerModal}
                backgroundColor={backgroundColor}
                field={fieldRest}
                {...fieldRest}
              />
            )}
          />
          <FilterToggleGroupContainer>
            <FormGroupWithoutBorderBottom>
              <FieldHead>
                <div>
                  <strong>Filter Graphics</strong>
                </div>
                <div
                  style={{
                    width: "100%",
                    margin: "0 auto 1em auto",
                    padding: "0 1em 0 1em",
                  }}
                >
                  <Controller
                    control={control}
                    name="with_photo_filter"
                    render={({ field: { ref, ...fieldRest } }) => (
                      <SwitchField
                        name="with_photo_filter"
                        baseSwitch
                        label="Photo filter enabled "
                        field={fieldRest}
                        {...fieldRest}
                      />
                    )}
                  />
                </div>
              </FieldHead>
            </FormGroupWithoutBorderBottom>
          </FilterToggleGroupContainer>
        </div>
      </div>
      <div className="channel-forms__group">
        {edit ? (
          <Button
            type="submit"
            disabled={submitting || pristine}
          >
            Save
          </Button>
        ) : (
          <Button
            type="button"
            onClick={() => nextTab()}
            disabled={submitting || pristine}
          >
            Save and Next
          </Button>
        )}
      </div>
    </StyledForm>
  ) : (
    <DisabledTabWrapper>
      <H4>Please select a theme</H4>
      <Button type="button" onClick={goToThemeTab}>
        Back To Themes
      </Button>
    </DisabledTabWrapper>
  );
};

const mapStateToProps = null;

const mapDispatchToProps = (dispatch) => ({
  goToThemeTab: () => dispatch(changeTab(1)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LogoForm);
